import styles from './fas.module.scss';
import { TextField } from '@frontend-workspace/react-shared-lib';
import { ILoan } from 'libs/webkua-lib/src/lib/_models/loan';
import { Col, Row } from 'reactstrap';
import { dateFormatter } from 'libs/webkua-lib/src/lib/helpers';
import { useTranslation } from 'react-i18next';

/* eslint-disable-next-line */
export interface FasProps {
  loan?: ILoan
}

export function Fas(props: FasProps) {
  const { t } = useTranslation();

  return (
    <Row>
      <Col md={6} xxl={4}>
        <div className="d-flex flex-column mb-3">
          <TextField
            value={props.loan?.fasInfo?.fileName || ''}
            fullWidth
            label={t("standard.fileName")}
            disabled
            className='mb-3'
          />
          <TextField
            value={props.loan?.fasInfo?.fileVersion || ''}
            fullWidth
            label={t("standard.fileVersion")}
            disabled
            className='mb-3'
          />
        </div>
      </Col>
      <Col md={6} xxl={4}>
        <div className="d-flex flex-column mb-3">
          <TextField
            value={props.loan?.fasInfo?.pid || ''}
            fullWidth
            label="P ID"
            disabled
            className='mb-3'
          />
          <TextField
            value={props.loan?.fasInfo?.sessionId || ''}
            fullWidth
            label={t("standard.sessionID")}
            disabled
            className='mb-3'
          />
        </div>
      </Col>
      <Col md={6} xxl={4}>
        <div className="d-flex flex-column mb-3">
          <TextField
            value={dateFormatter(props.loan?.fasInfo?.start)}
            fullWidth
            label={t("standard.started")}
            disabled
            className='mb-3'
          />
          <TextField
            value={dateFormatter(props.loan?.fasInfo?.stop)}
            fullWidth
            label={t("standard.stopped")}
            disabled
            className='mb-3'
          />
        </div>
      </Col>
    </Row>
  );
}

export default Fas;